import * as PIXI from 'pixi.js';
import { IPoint } from 'framework/utils/math-utils';
import { pxToSpacePosition } from 'js/bubbleCore/view/utils/pxToSpacePosition';
import { pxToHexPosition } from 'js/bubbleCore/view/utils/pxToHexPosition';
import { BubbleGameBoardView } from 'js/bubbleCore/view/BubbleGameBoardView';
import { Signal } from 'framework/utils/Signal';

export interface ICoords {
  global: IPoint;
  local: IPoint;
  hexSpace: IPoint;
  hex: IPoint;
}

export class InputCatcher extends PIXI.Sprite {
  public signals = {
    onPointerMove: new Signal<ICoords>(),
    onPointerDown: new Signal<ICoords>(),
    onPointerUp: new Signal<ICoords>(),
  }

  private boardView: BubbleGameBoardView;
  private readonly coords: ICoords = {
    global: {x: 0, y: 0},
    local: {x: 0, y: 0},
    hexSpace: {x: 0, y: 0},
    hex: {x: 0, y: 0},
  }

  constructor(boardView: BubbleGameBoardView) {
    super();
    this.boardView = boardView;

    const {width, height} = boardView.getBoardPixelSize()
    this.hitArea = new PIXI.Rectangle(0, 0, width, height);

    this.interactive = true;
    this.on('pointerdown', (e: PIXI.interaction.InteractionEvent) => {
      this.updatePositions(e.data.global);
      this.signals.onPointerDown.dispatch(this.getCoords());
    });

    this.on('pointerup', (e: PIXI.interaction.InteractionEvent) => {
      this.updatePositions(e.data.global);
      this.signals.onPointerUp.dispatch(this.getCoords());
    });

    this.on('pointermove', (e: PIXI.interaction.InteractionEvent) => {
      this.updatePositions(e.data.global);
      this.signals.onPointerMove.dispatch(this.getCoords());
    });
  }

  public getCoords(): ICoords {
    return this.coords;
  }

  private updatePositions(global: PIXI.Point): void {
    this.coords.global.x = global.x;
    this.coords.global.y = global.y;

    const {x, y} = this.toLocal(global);
    this.coords.local.x = x;
    this.coords.local.y = y;

    const {x: hexSpaceX, y: hexSpaceY} = pxToSpacePosition(x, y, this.boardView.getHexPixelSize());
    this.coords.hexSpace.x = hexSpaceX;
    this.coords.hexSpace.y = hexSpaceY;

    const {x: gridSpaceX, y: gridSpaceY} = pxToHexPosition(
      this.boardView.getData().grid,
      x, y,
      this.boardView.getHexPixelSize()
    );

    this.coords.hex.x = gridSpaceX;
    this.coords.hex.y = gridSpaceY;
  }
}